import React, { Component } from "react"
import PropTypes from "prop-types"
import { Hyperlink } from "components"
import { withRadium } from "higher-order-components"

class ExpandableInfo extends Component {
  constructor(props) {
    super(props)
    this.state = {
      open: props.isOpen
    }
  }
  render() {
    const {
      mainText, description, styleName, descriptionStyle, textAlign
    } = this.props
    const { open } = this.state
    return (
      <div
        style={{
          margin: "auto",
          textAlign,
          cursor: "pointer",
          paddingBottom: "1em"
        }}>
        <Hyperlink
          onClick={() => this.setState({ open: !open })}
          text={mainText}
          styleName={styleName} />
        <div
          data-test="expandable-description"
          style={[
            {
              textAlign: "left",
              margin: open ? "1em auto 0" : "0",
              fontWeight: 300,
              lineHeight: 1.4,
              overflow: "hidden",
              fontSize: "90%",
              color: "#939393",
              maxHeight: open ? "50em" : "0em",
              transition: "max-height 0.2s ease-in"
            },
            descriptionStyle
          ]}
          dangerouslySetInnerHTML={{ __html: description }} />
      </div>
    )
  }
}

ExpandableInfo.propTypes = {
  mainText: PropTypes.string,
  description: PropTypes.string,
  styleName: PropTypes.string,
  isOpen: PropTypes.bool,
  descriptionStyle: PropTypes.object,
  textAlign: PropTypes.string
}

ExpandableInfo.defaultProps = {
  isOpen: false,
  textAlign: "center"
}

export default withRadium()(ExpandableInfo)



// WEBPACK FOOTER //
// ./src/containers/expandable-info/index.jsx